import themeBreakpoints from './breakpoints';
import themeIndents from './indents';
import borderRadii from './radii';
import { TTheme } from './types';
import themeHeaders from './typography.headers';
import themeText from './typography.paragraphs';

const commonTheme: Omit<TTheme, 'colors'> = {
    typography: {
        font: {
            bold: 'CoFoSansBold, Helvetica, sans-serif',
            medium: 'CoFoSansMedium, Helvetica, sans-serif',
            regular: 'CoFoSansRegular, Helvetica, sans-serif',
        },
        headers: themeHeaders,
        text: themeText,
    },
    indents: themeIndents,
    breakpoints: themeBreakpoints,
    radii: borderRadii,
};

export default commonTheme;
